"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNullOrUndefined = void 0;
const isNullOrUndefined = (input) => input === null || input === undefined;
exports.isNullOrUndefined = isNullOrUndefined;
